{
  "version": 1,
  "asset_id": "b20a82ed-d136-43d2-beda-6250b729b296",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/b20a82ed-d136-43d2-beda-6250b729b296/hartmann.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/b20a82ed-d136-43d2-beda-6250b729b296/hartmann.png",
  "original_filename": "hartmann.png",
  "size": 7910,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:38Z"
}
